export default __webpack_public_path__ + "static/media/e41.d6d66197.jpeg";